import { render, staticRenderFns } from "./CategoriesDetail.vue?vue&type=template&id=fc17b5ae&scoped=true&"
import script from "./CategoriesDetail.vue?vue&type=script&lang=js&"
export * from "./CategoriesDetail.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesDetail.vue?vue&type=style&index=0&id=fc17b5ae&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc17b5ae",
  null
  
)

export default component.exports